"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3085],{

/***/ 2305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "pencil_svg__h-5 pencil_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.414 2.586a2 2 0 0 0-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 0 0 0-2.828z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6a2 2 0 0 1 2-2h4a1 1 0 0 1 0 2H4v10h10v-4a1 1 0 1 1 2 0v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgPencil);

/***/ }),

/***/ 7700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "user_svg__h-6 user_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-4 7a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgUser);

/***/ }),

/***/ 3085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ standard_layout; },
  "K": function() { return /* binding */ getStandardLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(8522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 79 modules
var features_animation = __webpack_require__(6894);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(1190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 28 modules
var motion_minimal = __webpack_require__(1039);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/utils/dayjs.tsx
var dayjs = __webpack_require__(4752);
// EXTERNAL MODULE: ./src/components/modal/modal-provider.tsx
var modal_provider = __webpack_require__(2109);
// EXTERNAL MODULE: ./src/components/user-provider.tsx
var user_provider = __webpack_require__(7348);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/logo.tsx
/* provided dependency */ var process = __webpack_require__(3454);


const Logo = (props)=>{
    const { color =true  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "inline-flex select-none items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)("font-semibold uppercase tracking-widest", {
                    "text-primary-500": color
                }, props.className),
                children: "Beta"
            }),
            process.env.NEXT_PUBLIC_BETA === "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "ml-2 inline-block rounded bg-rose-500 px-1 text-xs lowercase tracking-tight text-slate-50",
                children: "beta"
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/components/auth/login-form.tsx
var login_form = __webpack_require__(6260);
;// CONCATENATED MODULE: ./src/components/auth/login-modal.tsx







const LoginModal = (param)=>{
    let { onDone  } = param;
    const [hasAccount, setHasAccount] = react.useState(false);
    const [defaultEmail, setDefaultEmail] = react.useState("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[420px] max-w-full overflow-hidden bg-white shadow-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-pattern border-b border-t-4 border-t-primary-500 bg-slate-500/5 p-4 text-center sm:p-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                    className: "text-2xl"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-4 sm:p-6",
                children: hasAccount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(login_form/* RegisterForm */.B, {
                    defaultValues: {
                        email: defaultEmail
                    },
                    onRegistered: onDone,
                    onClickLogin: (e)=>{
                        e.preventDefault();
                        setHasAccount(false);
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(login_form/* LoginForm */.U, {
                    onAuthenticated: onDone,
                    onClickRegister: (e, email)=>{
                        e.preventDefault();
                        setDefaultEmail(email);
                        setHasAccount(true);
                    }
                })
            })
        ]
    });
};
const useLoginModal = ()=>{
    const modalContext = (0,modal_provider/* useModalContext */.v)();
    const { refresh  } = (0,user_provider/* useUser */.aF)();
    const openLoginModal = ()=>{
        modalContext.render({
            overlayClosable: false,
            showClose: true,
            content: function Content(param) {
                let { close  } = param;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal, {
                    onDone: ()=>{
                        refresh();
                        close();
                    }
                });
            },
            footer: null
        });
    };
    return {
        openLoginModal
    };
};
const LoginLink = (param)=>{
    let { children , className  } = param;
    const { openLoginModal  } = useLoginModal();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/login",
        onClick: (e)=>{
            e.preventDefault();
            openLoginModal();
        },
        className: className,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/icons/adjustments.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAdjustments = function SvgAdjustments(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "adjustments_svg__h-6 adjustments_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6V4m0 2a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m-6 8a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v2m0-6V4"
  })));
};

/* harmony default export */ var adjustments = (SvgAdjustments);
;// CONCATENATED MODULE: ./src/components/icons/beaker.svg
var beaker_path;

function beaker_extends() { beaker_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return beaker_extends.apply(this, arguments); }



var SvgBeaker = function SvgBeaker(props) {
  return /*#__PURE__*/react.createElement("svg", beaker_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "beaker_svg__h-6 beaker_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), beaker_path || (beaker_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.428 15.428a2 2 0 0 0-1.022-.547l-2.387-.477a6 6 0 0 0-3.86.517l-.318.158a6 6 0 0 1-3.86.517L6.05 15.21a2 2 0 0 0-1.806.547M8 4h8l-1 1v5.172a2 2 0 0 0 .586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 0 0 9 10.172V5L8 4z"
  })));
};

/* harmony default export */ var beaker = (SvgBeaker);
;// CONCATENATED MODULE: ./src/components/icons/home.svg
var home_path;

function home_extends() { home_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return home_extends.apply(this, arguments); }



var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/react.createElement("svg", home_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "home_svg__h-6 home_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), home_path || (home_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3 12 2-2m0 0 7-7 7 7M5 10v10a1 1 0 0 0 1 1h3m10-11 2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"
  })));
};

/* harmony default export */ var home = (SvgHome);
;// CONCATENATED MODULE: ./src/components/icons/login.svg
var login_path;

function login_extends() { login_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return login_extends.apply(this, arguments); }



var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/react.createElement("svg", login_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "login_svg__h-6 login_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), login_path || (login_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11 16-4-4m0 0 4-4m-4 4h14m-5 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v1"
  })));
};

/* harmony default export */ var login = (SvgLogin);
;// CONCATENATED MODULE: ./src/components/icons/menu.svg
var menu_path;

function menu_extends() { menu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }



var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", menu_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "menu_svg__h-6 menu_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), menu_path || (menu_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 6h16M4 12h16M4 18h16"
  })));
};

/* harmony default export */ var menu = (SvgMenu);
// EXTERNAL MODULE: ./src/components/icons/pencil.svg
var pencil = __webpack_require__(2305);
;// CONCATENATED MODULE: ./src/components/icons/support.svg
var support_path;

function support_extends() { support_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return support_extends.apply(this, arguments); }



var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/react.createElement("svg", support_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "support_svg__h-6 support_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), support_path || (support_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.364 5.636-3.536 3.536m0 5.656 3.536 3.536M9.172 9.172 5.636 5.636m3.536 9.192-3.536 3.536M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zm-5 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"
  })));
};

/* harmony default export */ var support = (SvgSupport);
;// CONCATENATED MODULE: ./src/components/icons/user-circle.svg
var user_circle_path;

function user_circle_extends() { user_circle_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_circle_extends.apply(this, arguments); }



var SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/react.createElement("svg", user_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "user-circle_svg__h-6 user-circle_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), user_circle_path || (user_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.121 17.804A13.937 13.937 0 0 1 12 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
  })));
};

/* harmony default export */ var user_circle = (SvgUserCircle);
// EXTERNAL MODULE: ./src/components/popover.tsx
var popover = __webpack_require__(314);
// EXTERNAL MODULE: ./src/components/poll/language-selector.tsx
var language_selector = __webpack_require__(4563);
;// CONCATENATED MODULE: ./src/components/preferences.tsx







const Preferences = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)([
        "app",
        "common"
    ]);
    const { weekStartsOn , setWeekStartsOn , timeFormat , setTimeFormat  } = (0,dayjs/* useDayjs */.a)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2 space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow text-sm text-slate-500",
                        children: t("common:language")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(language_selector/* LanguageSelect */.S, {
                        className: "w-full",
                        onChange: ()=>router.reload()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grow space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-2 grow text-sm text-slate-500",
                                children: t("app:weekStartsOn")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "segment-button inline-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (0,clsx_m/* default */.Z)({
                                                "segment-button-active": weekStartsOn === "monday"
                                            }),
                                            onClick: ()=>{
                                                setWeekStartsOn("monday");
                                            },
                                            type: "button",
                                            children: t("app:monday")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (0,clsx_m/* default */.Z)({
                                                "segment-button-active": weekStartsOn === "sunday"
                                            }),
                                            onClick: ()=>{
                                                setWeekStartsOn("sunday");
                                            },
                                            type: "button",
                                            children: t("app:sunday")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-2 grow text-sm text-slate-500",
                                children: t("app:timeFormat")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "segment-button inline-flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,clsx_m/* default */.Z)({
                                            "segment-button-active": timeFormat === "12h"
                                        }),
                                        onClick: ()=>{
                                            setTimeFormat("12h");
                                        },
                                        type: "button",
                                        children: t("app:12h")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,clsx_m/* default */.Z)({
                                            "segment-button-active": timeFormat === "24h"
                                        }),
                                        onClick: ()=>{
                                            setTimeFormat("24h");
                                        },
                                        type: "button",
                                        children: t("app:24h")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var preferences = (Preferences);

// EXTERNAL MODULE: ./src/components/dropdown.tsx + 1 modules
var dropdown = __webpack_require__(8875);
;// CONCATENATED MODULE: ./src/components/open-beta-modal.tsx


const OpenBeta = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-pattern border-b px-4 py-8 text-center text-2xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-3xl p-3 sm:p-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "The open beta allows you to test out new features before they are officially released to the general public. By participating you, will have the opportunity to provide feedback and help shape the future of Rallly!"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Feedback"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "grid grid-cols-1 gap-4 md:grid-cols-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://github.com/lukevella/rallly/issues/new?assignees=&labels=bug&template=---bug-report.md&title=",
                                        className: "rounded border p-3 hover:text-primary-500",
                                        children: "\uD83D\uDC1E Submit a bug report"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://github.com/lukevella/rallly/discussions/new/choose",
                                        className: "rounded border p-3 hover:text-primary-500",
                                        children: "\uD83D\uDCE2 Open a discussion with the community"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://discord.gg/uzg4ZcHbuM",
                                        className: "rounded border p-3 hover:text-primary-500",
                                        children: "\uD83D\uDCAC Chat on Discord"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:feedback@rallly.co",
                                        className: "rounded border p-3 hover:text-primary-500",
                                        children: "✉️ Send an email"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-patte mt-4 rounded border bg-slate-50 p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-slate-800",
                                        children: "Important"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "You should not rely on the beta for any important data or information."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "The beta should be used exclusively for testing purposes. Features, polls, accounts, or data may be removed at any time without prior notice."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "m-0",
                                        children: "Any data or information saved on the beta website cannot be accessed on the production website and vice versa."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var open_beta_modal = (OpenBeta);

;// CONCATENATED MODULE: ./src/components/icons/logout.svg
var logout_path;

function logout_extends() { logout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logout_extends.apply(this, arguments); }



var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/react.createElement("svg", logout_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "logout_svg__h-6 logout_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), logout_path || (logout_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m17 16 4-4m0 0-4-4m4 4H7m6 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1"
  })));
};

/* harmony default export */ var icons_logout = (SvgLogout);
;// CONCATENATED MODULE: ./src/components/icons/question-mark-circle.svg
var question_mark_circle_path;

function question_mark_circle_extends() { question_mark_circle_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return question_mark_circle_extends.apply(this, arguments); }



var SvgQuestionMarkCircle = function SvgQuestionMarkCircle(props) {
  return /*#__PURE__*/react.createElement("svg", question_mark_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "question-mark-circle_svg__h-6 question-mark-circle_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), question_mark_circle_path || (question_mark_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
  })));
};

/* harmony default export */ var question_mark_circle = (SvgQuestionMarkCircle);
// EXTERNAL MODULE: ./src/components/icons/user.svg
var icons_user = __webpack_require__(7700);
;// CONCATENATED MODULE: ./src/components/layouts/standard-layout/user-dropdown.tsx











const UserDropdown = (param)=>{
    let { children , ...forwardProps } = param;
    const { logout , user  } = (0,user_provider/* useUser */.aF)();
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "app"
    ]);
    const { openLoginModal  } = useLoginModal();
    const modalContext = (0,modal_provider/* useModalContext */.v)();
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown/* default */.Z, {
        ...forwardProps,
        children: [
            children,
            user.isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                icon: question_mark_circle,
                label: t("app:whatsThis"),
                onClick: ()=>{
                    modalContext.render({
                        showClose: true,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-96 max-w-full p-6 pt-28",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute left-0 -top-8 w-full text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inline-flex h-20 w-20 items-center justify-center rounded-full border-8 border-white bg-gradient-to-b from-purple-400 to-primary-500",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_user/* default */.Z, {
                                                className: "h-7 text-white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-lg font-medium leading-snug",
                                                    children: "Guest"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-sm text-slate-500",
                                                    children: user.shortName
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("app:guestSessionNotice")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://support.rallly.co/guest-sessions",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: "text-link",
                                        children: t("app:guestSessionReadMore")
                                    })
                                })
                            ]
                        }),
                        overlayClosable: true,
                        footer: null
                    });
                }
            }) : null,
            !user.isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                href: "/profile",
                icon: icons_user/* default */.Z,
                label: t("app:yourProfile")
            }) : null,
            user.isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                icon: login,
                label: t("app:login"),
                onClick: openLoginModal
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                icon: icons_logout,
                label: user.isGuest ? t("app:forgetMe") : t("app:logout"),
                onClick: ()=>{
                    if (user === null || user === void 0 ? void 0 : user.isGuest) {
                        modalContext.render({
                            title: t("app:areYouSure"),
                            description: t("app:endingGuestSessionNotice"),
                            onOk: logout,
                            okButtonProps: {
                                type: "danger"
                            },
                            okText: t("app:endSession"),
                            cancelText: t("app:cancel")
                        });
                    } else {
                        logout();
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/layouts/standard-layout/mobile-navigation.tsx
/* provided dependency */ var mobile_navigation_process = __webpack_require__(3454);






















const MobileNavigation = (props)=>{
    const { user , isUpdating  } = (0,user_provider/* useUser */.aF)();
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "app"
    ]);
    const [isPinned, setIsPinned] = react.useState(false);
    const modalContext = (0,modal_provider/* useModalContext */.v)();
    react.useEffect(()=>{
        const scrollHandler = ()=>{
            if (window.scrollY > 0) {
                setIsPinned(true);
            } else {
                setIsPinned(false);
            }
        };
        window.addEventListener("scroll", scrollHandler);
        return ()=>{
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("sticky top-0 z-40 flex w-full shrink-0 items-center justify-between border-b p-2 transition-all", {
            "bg-gray-50/75 shadow-sm backdrop-blur-md ": isPinned,
            "border-transparent bg-gray-50/0 shadow-none": !isPinned
        }, props.className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown/* default */.Z, {
                    placement: "bottom-start",
                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        role: "button",
                        type: "button",
                        className: "group flex items-center rounded px-2 py-1 font-medium text-slate-600 transition-colors hover:bg-gray-200 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu, {
                                className: "mr-2 w-5 group-hover:text-primary-500"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
                        ]
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                            href: "/",
                            label: t("home"),
                            icon: home
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                            href: "/new",
                            label: t("app:createNew"),
                            icon: pencil/* default */.Z
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                            href: "https://support.rallly.co",
                            label: t("support"),
                            icon: support
                        }),
                        mobile_navigation_process.env.NEXT_PUBLIC_BETA === "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                                onClick: ()=>{
                                    // open modal
                                    modalContext.render({
                                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(open_beta_modal, {}),
                                        footer: null,
                                        showClose: true,
                                        overlayClosable: true
                                    });
                                },
                                label: "Feedback",
                                icon: beaker
                            })
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    user ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginLink, {
                        className: "flex w-full cursor-pointer items-center space-x-2 whitespace-nowrap rounded px-2 py-1 font-medium text-slate-600 transition-colors hover:bg-gray-200 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(login, {
                                className: "h-5 opacity-75"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block",
                                children: t("app:login")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        initial: false,
                        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDropdown, {
                            placement: "bottom-end",
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                role: "button",
                                "data-testid": "user",
                                className: (0,clsx_m/* default */.Z)("group inline-flex w-full items-center space-x-2 rounded px-2 py-1 text-left transition-colors hover:bg-slate-500/10 active:bg-slate-500/20", {
                                    "opacity-50": isUpdating
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative shrink-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(user_circle, {
                                            className: "w-5 opacity-75 group-hover:text-primary-500 group-hover:opacity-100"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "max-w-[120px] truncate font-medium xs:block",
                                        children: user.isGuest ? t("app:guest") : user.shortName
                                    })
                                ]
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverTrigger */.xo, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    role: "button",
                                    type: "button",
                                    className: "group flex items-center whitespace-nowrap rounded px-2 py-1 font-medium text-slate-600 transition-colors hover:bg-gray-200 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(adjustments, {
                                            className: "h-5 opacity-75 group-hover:text-primary-500"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-2 hidden sm:block",
                                            children: t("app:preferences")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverContent */.yk, {
                                align: "end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(preferences, {
                                    className: "p-2"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/layouts/standard-layout.tsx








const StandardLayout = (param)=>{
    let { children , ...rest } = param;
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
        features: features_animation/* domAnimation */.H,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(user_provider/* UserProvider */.dr, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dayjs/* DayjsProvider */.L, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_provider/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-pattern relative min-h-full",
                        ...rest,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavigation, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto max-w-4xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                    initial: false,
                                    exitBeforeEnter: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        initial: {
                                            opacity: 0,
                                            y: -50
                                        },
                                        animate: {
                                            opacity: 1,
                                            y: 0
                                        },
                                        exit: {
                                            opacity: 0,
                                            y: -50
                                        },
                                        children: children
                                    }, router.asPath)
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var standard_layout = (StandardLayout);
const getStandardLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardLayout, {
        children: page
    });
};


/***/ })

}]);